var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4757_6226)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.044 13.8956C12.7227 14.1847 12.289 14.3614 11.8231 14.3614C11.3573 14.3614 10.9235 14.1847 10.6022 13.8956C8.78697 17.7028 3.95163 18.2329 4.61027 20.2249C5.31709 22.3293 10.7468 23.5341 12.4175 22.7631C14.2328 21.9277 13.3332 15.8876 13.1565 13.8956H13.0279H13.044Z",
    stroke: "#4E5B5E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8955 10.8916C14.1847 11.2129 14.3614 11.6466 14.3614 12.1125C14.3614 12.5783 14.1847 13.0121 13.8955 13.3333C17.7027 15.1486 18.2329 19.9839 20.2248 19.3253C22.3292 18.6185 23.5341 13.1888 22.763 11.5181C21.9276 9.70281 15.8875 10.6024 13.8955 10.7791V10.9076V10.8916Z",
    stroke: "#4E5B5E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1043 13.1084C9.81515 12.7872 9.63844 12.3534 9.63844 11.8876C9.63844 11.4217 9.81515 10.988 10.1043 10.6667C6.29708 8.85141 5.76696 4.01607 3.77499 4.6747C1.67057 5.38153 0.465751 10.8112 1.23684 12.4819C2.07218 14.2972 8.11234 13.3976 10.1043 13.2209V13.0924V13.1084Z",
    stroke: "#4E5B5E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8593 10.1044C11.1806 9.81526 11.6143 9.63856 12.0802 9.63856C12.5461 9.63856 12.9798 9.81526 13.3011 10.1044C15.1163 6.29719 19.9517 5.76707 19.293 3.7751C18.5862 1.67068 13.1565 0.465865 11.4858 1.23695C9.67056 2.07229 10.5702 8.11245 10.7469 10.1044H10.8754H10.8593Z",
    stroke: "#4E5B5E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.016 14.4096C13.3202 14.4096 14.3774 13.3524 14.3774 12.0482C14.3774 10.744 13.3202 9.68675 12.016 9.68675C10.7118 9.68675 9.65454 10.744 9.65454 12.0482C9.65454 13.3524 10.7118 14.4096 12.016 14.4096Z",
    fill: "white",
    stroke: "#4E5B5E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4757_6226"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFan);
export default __webpack_public_path__ + "static/media/icon_fan.bcdaca0a7f0a4729ebf05f3d48338fa7.svg";
export { ForwardRef as ReactComponent };